<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-10">
          <wizard>
            <template slot="header">
              <h3 class="card-title">Setup your digital financial accountant</h3>
              <h3 class="description">Kobotrack use these information to work on 
                your behalf</h3>
            </template>

            <wizard-tab :before-change="() => validateStep('step1')">
              <template slot="label">
                <i class="ti-arrow-down"></i>
                Step 1
              </template>
              <first-step ref="step1" @on-validated="onStepValidated"></first-step>
            </wizard-tab>

            <wizard-tab :before-change="() => validateStep('step2')">
              <template slot="label">
                <i class="ti-pie-chart"></i>
                Step 2
              </template>
              <second-step ref="step2" @on-validated="onStepValidated"></second-step>
            </wizard-tab>

            <wizard-tab :before-change="() => validateStep('step3')">
              <template slot="label">
                <i class="ti-face-sad"></i>
                Step 3
              </template>
              <third-step ref="step3" @on-validated="onStepValidated"></third-step>
            </wizard-tab>

            <wizard-tab :before-change="() => validateStep('step4')">
              <template slot="label">
                <i class="ti-wallet"></i>
                Step 4
              </template>
              <fourth-step ref="step4" @on-validated="onStepValidated"></fourth-step>
            </wizard-tab>
            <wizard-tab :before-change="() => wizardComplete()">
              <template slot="label">
                <i class="ti-eye"></i>
                Step 5
              </template>
              <fifth-step ref="step5" :wizardModel="wizardModel"></fifth-step>
            </wizard-tab>
          </wizard>
      </div>
    </div>
  </div>
</template>
<script>
  import auth from 'src/auth'

  import FirstStep from './Wizard/FirstStep.vue'

  import SecondStep from './Wizard/SecondStep.vue'
  import ThirdStep from './Wizard/ThirdStep.vue'
  import FourthStep from './Wizard/FourthStep.vue'
  import FifthStep from './Wizard/FifthStep.vue'
  import swal from 'sweetalert2'
  import {Wizard, WizardTab } from 'src/components/UIComponents'

  export default {
    data() {
      return {
        wizardModel: {}
      }
    },
    components: {
      FirstStep,
      SecondStep,
      ThirdStep,
      FourthStep,
      FifthStep,
      Wizard,
      WizardTab
    },
    methods: {
      validateStep(ref) {
        return this.$refs[ref].validate()
      },
      onStepValidated(validated, model) {
        this.wizardModel = {...this.wizardModel, ...model}
      },

      async wizardComplete () {
        const validatedStep3 = this.validateStep('step3')
        const validatedStep3Result = await validatedStep3
        
        if (!validatedStep3Result) { return false }
        
        this.onStepValidated

        auth.getToken()
        auth.setHeaderAuthorization(this.$http)
        this.$http.post('/onboarding/wizard', {
           data: this.wizardModel
          })
          .then(response =>{
            if(response.status == 201 && response.data.message == 'successful'){
              
              this.$router.push('/verify')
            }
          })
          .catch(error => {
            console.error(error);
          })
      }
    }
  }
</script>

<style scoped>
  body { background: #2c2c2c !important;  }
  .row {margin-right: 0px; margin-left: 0px }
</style>
